
import { chain, LoadRealTimePricing} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { addToChainAfter } from "@preferredMedical/HandlerCreator";
import UpdateProductInfoLoadRealTimeInventory from "@preferredMedical/NdcHandlersChanged/CommonHandlers/UpdateProductInfoLoadRealTimeInventory";

const ProductInfoListsChangeUpdateProductinfoHandler = () => {
    addToChainAfter(
        chain,
        LoadRealTimePricing,
        UpdateProductInfoLoadRealTimeInventory,
    );
};

export default ProductInfoListsChangeUpdateProductinfoHandler;
